import * as types from './actionTypes';
import _ from 'lodash';
import axios from 'axios';

import dataContent from '../data/content.json';
import dataEmrays from '../data/emrays.json';

// Text Delta

export const addDelta = (delta) => {
  return {
    type: types.ADD_DELTA,
    delta: delta
  };
}

export const clearDeltaArray = () => {
  return {
    type: types.CLEAR_DELTA_ARRAY
  };
}

export const setDoOutputDeltas = (value) => {
  return {
    type: types.SET_DO_OUTPUT_DELTAS,
    doOutputDeltas: value
  };
}

// Film Slider

export const setSliderValue = (value) => {
  return {
    type: types.SET_SLIDER_VALUE,
    sliderValue: value
  };
}

export const setFilmSliderProject = (objProject) => {
  return {
    type: types.SET_FILM_SLIDER_PROJECT,
    filmProjectObject: objProject || null
  };
}

// Moodboard

export const setPauseUpdate = (doPause) => {
  return {
    type: types.SET_PAUSE_UPDATE,
    pauseUpdate: doPause,
  };
}

export const setSelectedMovieId = (id) => {
  return {
    type: types.SET_SELECTED_MOVIE,
    selectedMovieId: id,
  };
}

export const setBeatContainerHeight = (height) => {
  return {
    type: types.SET_BEAT_CONTAINER_HEIGHT,
    beatContainerHeight: height,
  };
}

export const setBeatLoadingStates = (beatId, states) => {
  return {
    type: types.SET_BEAT_LOADING_STATES,
    id: beatId,
    loadingStates: states
  };
}

export const setIsChartShowing = (isChartShowing) => {
  return {
    type: types.SET_IS_CHART_SHOWING,
    isChartShowing: isChartShowing
  };
}

export const setBeatSearchQuery = (beatId, searchQuery, value) => {
  return {
    type: types.SET_BEAT_SEARCH_QUERY,
    id: beatId,
    query: searchQuery,
    value: value
  };
}

export const setBeatDropdownOptions = (beatId, options) => {
  return {
    type: types.SET_BEAT_DROPDOWN_OPTIONS,
    id: beatId,
    options: options
  };
}

export const setBeatQuery = (beatId, searchQuery) => {
  return {
    type: types.SET_BEAT_QUERY,
    id: beatId,
    query: searchQuery,
  };
}

export const setBeatSelectedPhoto = (beatId, imageSrc) => {
  return {
    type: types.SET_BEAT_SELECTED_PHOTO,
    id: beatId,
    imageSrc: imageSrc,
  };
}

export const getPhotos = (beatId, searchTerm) => {
  return (dispatch) => {
    axios.get(`https://api.pexels.com/v1/search?per_page=9&page=1&query=${searchTerm}`, {
      headers: { "Authorization" : dataContent['mood-board'].constants.API_KEY_PEXELS }
    })
    .then((response) => {
      const photos = response.data ? response.data.photos : [];

      dispatch(setPhotos(beatId, photos));
    })
    .catch((error) => console.error(error))
    .finally(() => dispatch(setBeatLoadingStates(beatId, { isPhotoListLoading: false })))
  };
}

export const setPhotos = (beatId, photos) => {
  return {
    type: types.SET_BEAT_PHOTOS,
    id: beatId,
    photos: photos
  };
}

const debug = true;

export const getImageEmotionData = (beatId, imageSrc) => {
  return (dispatch) => {
    axios.get(imageSrc, {
      responseType: 'arraybuffer'
    })
    .then((response) => {
      const blob = new Blob([response.data]);
      const formData = new FormData();
      const pureUrl = imageSrc.split('?')[0];
      const existingData = _.find(dataEmrays, [ "url", pureUrl ]);

      formData.append('apikey', dataContent['mood-board'].constants.API_KEY_EMRAYS);
      formData.append('file', blob, pureUrl);

      if (debug) {
        if (existingData) {
          dispatch(setEmotionData(beatId, Object.assign({}, existingData.response.emotions[0], { compound: existingData.response.compound })));
        }
        else {
          dispatch(setEmotionData(beatId, { love: _.random(0, 100) / 100, smile: _.random(0, 100) / 100, surprise: _.random(0, 100) / 100, sadness: _.random(0, 100) / 100, anxiety: _.random(0, 100) / 100 }));
        }

        dispatch(setBeatLoadingStates(beatId, { isChartLoading: false }));
      }
      else {
        axios.post('https://www8.emrays.com/api/v2/emotions', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => { 
          const emotions = response.data.emotions ? response.data.emotions[0] : {};

          if (!existingData) {
            console.log(JSON.stringify({ url: pureUrl, response: response.data }));
          }

          if (emotions) {
            dispatch(setEmotionData(beatId, { love: emotions.love, smile: emotions.smile, surprise: emotions.surprise, sadness: emotions.sadness, anxiety: emotions.anxiety, compound: response.data.compound }));
          }
        })
        .catch((error) => console.error(error))
        .finally(() => dispatch(setBeatLoadingStates(beatId, { isChartLoading: false })))
      }
    })
    .catch((error) => console.error(error));
  };
}

export const setEmotionData = (beatId, data, isBaseline = false) => {
  _.keys(data).forEach((key) => { 
    if (typeof data[key] === 'number') {
      data[key] = data[key];
    }
  })

  return {
    type: types.SET_EMOTION_DATA,
    id: beatId,
    isBaseline: isBaseline,
    data: data
  };
}



// WEBPACK FOOTER //
// ./src/actions/actionsExperiments.js